export default __webpack_public_path__ + "static/media/treasure_box_open.eebd1f57.png";